// extracted by mini-css-extract-plugin
export default {"container":"MyHangar_container__sbMMy","section":"MyHangar_section__EXgt1","itemsContainer":"MyHangar_itemsContainer__dj3LB","button":"MyHangar_button__w+4KB"};